import React, { useState } from 'react';
import './CalculatorPage.css'; // Generic CSS for calculator pages

function LuckyNumberCalculator() {
  const [input, setInput] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const calculate = (value) => {
    // Placeholder for Lucky Number calculation logic
    // This will need to be replaced with actual numerology logic
    if (!value) return null;
    let sum = 0;
    for (let i = 0; i < value.length; i++) {
      if (!isNaN(parseInt(value[i], 10))) {
        sum += parseInt(value[i], 10);
      }
    }
    while (sum > 9) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }
    return sum;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    if (!input) {
      setError('Please enter a value.');
      return;
    }

    const calculated = calculate(input);
    if (calculated === null) {
      setError('Invalid input. Please try again.');
    } else {
      setResult(calculated);
    }
  };

  const getExplanation = (num) => {
    // Placeholder for Lucky Number explanation
    return `Lucky Number ${num}: This is a placeholder explanation for Lucky Number ${num}.`;
  };

  // JSON-LD Structured Data for SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Lucky Number Calculator",
    "description": "Calculate your Lucky Number based on your birth date or name and understand its significance.",
    "url": "https://www.yourwebsite.com/lucky-number-calculator",
    "potentialAction": {
      "@type": "CalculateAction",
      "name": "Calculate Lucky Number",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/lucky-number-calculator?input={input}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=input"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Lucky Number Calculator</h1>
      <p className="text-center">Enter your details to discover your Lucky Number.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="input">Enter your Birth Date (DD/MM/YYYY) or Name:</label>
          <input
            type="text"
            id="input"
            className="form-control"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="e.g., 01/01/1990 or John Doe"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Calculate Lucky Number</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Your Lucky Number is: <span className="result-number">{result}</span></h2>
          <p className="result-explanation">{getExplanation(result)}</p>
        </div>
      )}
    </div>
  );
}

export default LuckyNumberCalculator;
